import { ResponseData } from "../APIs/types";
import { ActivateAccountRequest } from "../types/auth/activate-account.types";
import { httpClient } from "./common";
import { withApiErrorHandling } from "../APIs/withApiErrorHandling";

export class AuthAPI {
  private static readonly API_URL = "/auth";

  static async login(
    username: string,
    password: string
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () =>
        httpClient.post(
          `${AuthAPI.API_URL}/login`,
          { username, password },
          false
        ),
      "Error al iniciar sesión"
    );
  }

  static async refreshToken(refreshToken: string): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () =>
        httpClient.post(
          `${AuthAPI.API_URL}/refresh-token`,
          { refreshToken },
          false
        ),
      "Error al refrescar la sesión"
    );
  }

  static async register(
    username: string,
    password: string
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () =>
        httpClient.post(
          `${AuthAPI.API_URL}/register`,
          { username, password },
          false
        ),
      "Error al registrar usuario"
    );
  }

  static async activateAccount(
    data: ActivateAccountRequest
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.post(`${AuthAPI.API_URL}/activate`, data, true),
      "Error al activar cuenta"
    );
  }
}
